import { base } from '../base';


async function getListCustomer(param) {
  return base.get('catalogs/customers', param)
}

async function addNew(data) {
  return base.post('catalogs/customers', data)
}

async function update(data) {
  return base.put(`catalogs/customers`, data);
}

async function getListCustomerStore(param) {
  return base.get('catalogs/customer-stores', param)
}

async function addNewStore(data) {
  return base.post('catalogs/customer-stores', data)
}

async function updateStore(data) {
  return base.put(`catalogs/customer-stores`, data)
}

async function onSearchCustomer(data) {
  return base.get('telesales/order-processing/search-customer', data)
}

async function getListCustomerType(param) {
  return base.get('catalogs/customer/types', param)
}

async function getListCustomerGroup(param) {
  return base.get('catalogs/customer/groups', param)
}

async function addNewCustomerGroup(data) {
  return base.post('catalogs/customer/groups', data)
}

async function updateCustomerGroup(data) {
  return base.put(`catalogs/customer/groups`, data);
}

export const customerService = {
  addNew,
  getListCustomer,
  update,
  getListCustomerStore,
  addNewStore,
  updateStore,
  onSearchCustomer,
  getListCustomerGroup,
  getListCustomerType,
  addNewCustomerGroup,
  updateCustomerGroup
}